import Avatar from '@mui/material/Avatar'
import { useUserSelector } from '../../v2/store/users'

const getInitials = (name) => {
  if (!name) return undefined

  return name
    .split(' ')
    .filter((item) => item.length > 0)
    .map((word) => word.charAt(0))
    .join('')
}

export default function InitialAvatar ({ userName, email, className, onClick }) {
  const { imageUrl, email: emailFromStore } = useUserSelector()
  const avatarSx = (theme) => ({
    backgroundColor: theme.palette.quaternary.accent,
    color: theme.palette.quaternary.main
  })

  if (emailFromStore === email) {
    return (
      <Avatar className={className} src={imageUrl} onClick={onClick} sx={avatarSx} />
    )
  }

  return (
    <Avatar className={className} onClick={onClick} sx={avatarSx}>
      {getInitials(userName)}
    </Avatar>
  )
}
